(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.fcReady) return;
      root.dataset.fcReady = '1';
      var track = root.querySelector('[data-lh-fc-track]');
      var prev = root.querySelector('[data-lh-fc-prev]');
      var next = root.querySelector('[data-lh-fc-next]');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() { document.querySelectorAll('[data-lh-fc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-mobile-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bar = document.querySelector('[data-lh-tabbar]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var menu = bar.querySelector('[data-tabbar-menu]');
    var drawer = document.getElementById('LhDrawer');
    var openedHere = false;
    menu.addEventListener('click', function () {
      var burger = document.querySelector('.lh-header__burger');
      if (burger && drawer) { openedHere = true; burger.click(); }
      else window.location.href = menu.dataset.collectionsUrl;
    });
    if (drawer) {
      var syncMenu = function () {
        var open = !drawer.hasAttribute('hidden');
        menu.setAttribute('aria-expanded', String(open));
        if (!open && openedHere) {
          openedHere = false;
          requestAnimationFrame(function () { menu.focus({ preventScroll: true }); });
        }
      };
      new MutationObserver(syncMenu).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
      syncMenu();
    }
    var count = document.querySelector('.lh-header__count');
    var badge = bar.querySelector('[data-tabbar-count]');
    if (count && badge) {
      var syncCount = function () {
        var total = parseInt(count.textContent, 10) || 0;
        badge.textContent = total > 99 ? '99+' : total;
        badge.hidden = total === 0;
        badge.parentElement.parentElement.setAttribute('aria-label', 'Warenkorb, ' + total + ' Artikel');
      };
      new MutationObserver(syncCount).observe(count, { childList: true, characterData: true, subtree: true });
      syncCount();
    }
    if (window.visualViewport) {
      var syncKeyboard = function () {
        var field = document.activeElement;
        var typing = field && (field.tagName === 'TEXTAREA' || (field.tagName === 'INPUT' && !/^(button|submit|checkbox|radio|range|file|hidden)$/i.test(field.type)));
        bar.classList.toggle('is-keyboard-open', !!typing && window.innerHeight - window.visualViewport.height > 150);
      };
      window.visualViewport.addEventListener('resize', syncKeyboard, { passive: true });
      document.addEventListener('focusin', syncKeyboard);
      document.addEventListener('focusout', syncKeyboard);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var ICONS = {
      color: '<path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.5-.8 1.5-1.5 0-.9-.6-1.2-.6-2.1 0-.8.7-1.4 1.5-1.4H17a4 4 0 0 0 4-4C21 6.6 17 3 12 3z"/><circle cx="7.5" cy="11" r="1"/><circle cx="10.5" cy="7.5" r="1"/><circle cx="15" cy="7.5" r="1"/>',
      power: '<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/>',
      shield: '<path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/>',
      tool: '<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-.6-.6-2.4 2.6-2.6z"/>',
      light: '<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/>',
      leaf: '<path d="M5 19c0-8 5-13 15-14-1 10-6 15-14 15"/><path d="M5 19l7-7"/>'
    };
    function pickIcon(t) {
      t = t.toLowerCase();
      if (/lichtfarbe|cct|kelvin|farbtemperatur|dimm/.test(t)) return ICONS.color;
      if (/watt|leistung|effizien|energie|technik/.test(t)) return ICONS.power;
      if (/ip\d|schutz|innen|außen|feucht/.test(t)) return ICONS.shield;
      if (/montage|einbau|install/.test(t)) return ICONS.tool;
      if (/nachhaltig|langlebig|umwelt/.test(t)) return ICONS.leaf;
      return ICONS.light;
    }
    function svg(p) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    function buildContent(root) {
      var desc = root.querySelector('[data-pdp-desc]');
      if (!desc || desc.dataset.built) return;
      desc.dataset.built = '1';
      var headings = desc.querySelectorAll('h2, h3, h4');
      if (!headings.length) return;
      var parent = headings[0].parentElement;
      var intro = [], sections = [], current = null;
      Array.prototype.slice.call(parent.children).forEach(function (el) {
        if (/^H[2-4]$/.test(el.tagName)) { current = { title: el.textContent.trim(), nodes: [] }; sections.push(current); return; }
        if (el.tagName === 'HR') return;
        if (current) current.nodes.push(el); else intro.push(el);
      });
      if (!sections.length) return;

      var feats = [], glance = null;
      sections.forEach(function (s) {
        if (/vorteil|auf einen blick|highlights|überblick|technische|daten/i.test(s.title) && !glance) glance = s; else feats.push(s);
      });

      // Beschreibung: nur Einleitung
      parent.innerHTML = '';
      intro.forEach(function (n) { parent.appendChild(n); });
      if (!intro.length) { root.querySelector('#lh-tab-desc').hidden = true; root.querySelector('#lh-panel-desc').hidden = true; }

      // Eigenschaften-Karten
      if (feats.length) {
        var wrap = root.querySelector('[data-pdp-feats]');
        feats.forEach(function (s) {
          var card = document.createElement('article');
          card.className = 'lh-feat';
          card.innerHTML = '<span class="lh-feat__icon">' + svg(pickIcon(s.title + ' ' + s.nodes.map(function (n) { return n.textContent; }).join(' '))) + '</span><h3>' + esc(s.title.replace(/^[^\p{L}\p{N}]+/u, '')) + '</h3>';
          var body = document.createElement('div');
          s.nodes.forEach(function (n) { body.appendChild(n); });
          card.appendChild(body);
          wrap.appendChild(card);
        });
        root.querySelector('#lh-tab-feat').hidden = false;
      }

      // Auf einen Blick
      if (glance) {
        var items = [];
        glance.nodes.forEach(function (n) {
          var lis = n.tagName === 'LI' ? [n] : n.querySelectorAll('li');
          Array.prototype.forEach.call(lis, function (li) { items.push(li.textContent.trim()); });
        });
        if (items.length) {
          var rows = '', checks = '';
          items.forEach(function (t) {
            var m = t.match(/^([^:]{2,40}):\s*(.+)$/);
            if (m) rows += '<tr><th scope="row">' + esc(m[1]) + '</th><td>' + esc(m[2]) + '</td></tr>';
            else checks += '<li>' + esc(t) + '</li>';
          });
          var g = root.querySelector('[data-pdp-glance]');
          g.innerHTML = (rows ? '<table class="lh-glance__table"><tbody>' + rows + '</tbody></table>' : '') + (checks ? '<ul class="lh-glance__checks">' + checks + '</ul>' : '');
          root.querySelector('#lh-tab-high').hidden = false;

          var hl = document.querySelector('[data-pdp-highlights]');
          if (hl) {
            var short = items.filter(function (t) { return t.length <= 48; }).slice(0, 4);
            if (short.length >= 2) { hl.innerHTML = short.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join(''); hl.hidden = false; }
          }
        } else {
          feats.push(glance);
        }
      }
    }

    function initTabs(root) {
      if (root.dataset.tabsReady) return;
      root.dataset.tabsReady = '1';
      buildContent(root);
      var firstTab = Array.prototype.filter.call(root.querySelectorAll('[role="tab"]'), function (t) { return !t.hidden; })[0];
      var tabs = function () { return Array.prototype.filter.call(root.querySelectorAll('[role="tab"]'), function (t) { return !t.hidden; }); };
      function select(tab, focus) {
        tabs().forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) tab.focus();
      }
      if (firstTab) select(firstTab);
      root.addEventListener('click', function (e) { var t = e.target.closest('[role="tab"]'); if (t) select(t); });
      root.querySelector('[role="tablist"]').addEventListener('keydown', function (e) {
        var list = tabs(), i = list.indexOf(document.activeElement);
        if (i < 0) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); select(list[(i + 1) % list.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(list[(i - 1 + list.length) % list.length], true); }
        if (e.key === 'Home') { e.preventDefault(); select(list[0], true); }
        if (e.key === 'End') { e.preventDefault(); select(list[list.length - 1], true); }
      });
      document.querySelectorAll('[data-pdp-more]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var first = tabs()[0]; if (first) select(first);
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
    // ---------- PDF-Vorschau (Datenblatt) ----------
    var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
    var pdfLibPromise;
    function loadPdfJs() {
      if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
      if (!pdfLibPromise) {
        pdfLibPromise = new Promise(function (resolve, reject) {
          var s = document.createElement('script');
          s.src = PDFJS + 'pdf.min.js';
          s.onload = function () { window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js'; resolve(window.pdfjsLib); };
          s.onerror = function (e) { pdfLibPromise = null; reject(e); };
          document.head.appendChild(s);
        });
      }
      return pdfLibPromise;
    }
    function pdfDialog() {
      var d = document.getElementById('lh-pdf');
      if (d) return d;
      d = document.createElement('dialog');
      d.id = 'lh-pdf';
      d.className = 'lh-pdf';
      d.setAttribute('aria-label', 'Produktdatenblatt');
      d.innerHTML = '<div class="lh-pdf__bar"><strong class="lh-pdf__title"></strong><div class="lh-pdf__actions">' +
        '<a class="lh-pdf__btn" data-pdf-download download><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 4v11M7 10l5 5 5-5M5 20h14"/></svg><span>Herunterladen</span></a>' +
        '<button type="button" class="lh-pdf__close" aria-label="Schließen">&times;</button></div></div>' +
        '<div class="lh-pdf__body"><p class="lh-pdf__status"></p><div class="lh-pdf__pages"></div></div>';
      d.querySelector('.lh-pdf__close').addEventListener('click', function () { d.close(); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      d.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
      document.body.appendChild(d);
      return d;
    }
    function openPdf(url, title) {
      var d = pdfDialog();
      var pages = d.querySelector('.lh-pdf__pages');
      var status = d.querySelector('.lh-pdf__status');
      d.querySelector('.lh-pdf__title').textContent = title || 'Produktdatenblatt';
      d.querySelector('[data-pdf-download]').href = url;
      pages.innerHTML = '';
      status.hidden = false;
      status.textContent = 'Datenblatt wird geladen …';
      d.showModal();
      document.documentElement.style.overflow = 'hidden';
      loadPdfJs().then(function (lib) {
        return lib.getDocument(url).promise;
      }).then(function (pdf) {
        status.hidden = true;
        var width = pages.clientWidth || 800;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var chain = Promise.resolve();
        for (let i = 1; i <= pdf.numPages; i++) {
          chain = chain.then(function () { return pdf.getPage(i); }).then(function (page) {
            var base = page.getViewport({ scale: 1 });
            var vp = page.getViewport({ scale: (width / base.width) * dpr });
            var c = document.createElement('canvas');
            c.className = 'lh-pdf__page';
            c.width = Math.floor(vp.width);
            c.height = Math.floor(vp.height);
            c.setAttribute('aria-label', 'Seite ' + i + ' von ' + pdf.numPages);
            pages.appendChild(c);
            return page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise;
          });
        }
        return chain;
      }).catch(function () {
        status.hidden = false;
        status.innerHTML = 'Die Vorschau konnte nicht geladen werden. ';
        var a = document.createElement('a');
        a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'Datenblatt öffnen';
        status.appendChild(a);
      });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pdf-view]');
      if (!a) return;
      e.preventDefault();
      openPdf(a.href, a.getAttribute('data-pdf-title'));
    });

    function initAll() { document.querySelectorAll('[data-pdp-tabs]').forEach(initTabs); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
